"use client"

import { useState, useEffect, useRef, useContext } from "react"
import "../styles/navbar.css"
import logo from "../assets/logo.png"
import defaultAvatar from "../assets/default-avatar.png"
import { FaBars, FaTimes, FaSearch, FaSignInAlt, FaUser, FaBox, FaSignOutAlt, FaExchangeAlt, FaFileInvoiceDollar } from "react-icons/fa"
import { UserContext } from "../context/UserContext"
import { useNavigate } from "react-router-dom"

const Navbar = () => {
  const { user, logoutUser } = useContext(UserContext)
  const [sidebarOpen, setSidebarOpen] = useState(false)
  const [searchQuery, setSearchQuery] = useState("")
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const dropdownRef = useRef(null)
  const [isMobile, setIsMobile] = useState(false)
  const navigate = useNavigate()

  const handleLogout = () => {
    logoutUser()
    navigate("/") // redireciona para home
  }
  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false)
      }
    }
    document.addEventListener("mousedown", handleClickOutside)
    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [])
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768)
    handleResize()
    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])




  return (
    <nav className="navbar">
      {isMobile && (
        <div className="menu-icon2" onClick={() => setSidebarOpen(true)}>
          <FaBars />
        </div>
      )}

      <div className="logo-navbar">
        <a href="/">
          <img src={logo || "/placeholder.svg"} alt="Ticket do Vaqueiro" />
        </a>
      </div>


      <ul className="nav-menunavbar">
        <li>
          <a href="/quem-somos">Quem Somos</a>
        </li>
        <li>
          <a href="/vaquejadas">Vaquejadas</a>
        </li>
        <li>
          <a href="/ranking">Ranking</a>
        </li>
        <li>
          <a href="/como-contratar">Como Contratar?</a>
        </li>
        <li>
          <a href="/meus-pedidos">Minhas Senhas</a>
        </li>
        <li>
          <a href="/meus-boletos">Meus Boletos</a>
        </li>
      </ul>

      {user ? (
        <div className="user-sectionnavbar" ref={dropdownRef}>
          <div className="user-namenavbar" onClick={() => setDropdownOpen(!dropdownOpen)}>
            Olá, {user.nomeCompleto.split(" ")[0]}
          </div>
          <div className="user-menunavbar" onClick={() => setDropdownOpen(!dropdownOpen)}>
            <img src={user.profilePic ? user.profilePic : defaultAvatar} alt="Perfil" className="user-avatar" />
          </div>

          {dropdownOpen && (
            <div className={`dropdown-menu ${dropdownOpen ? "open" : ""}`}>
              <ul>
                <li>
                  <a href="/meus-dados">
                    <FaUser /> Meus Dados
                  </a>
                </li>
                <li>
                  <a href="/meus-pedidos">
                    <FaBox /> Meus Pedidos
                  </a>
                </li>
                <li>
                  <a href="/meus-boletos">
                    <FaFileInvoiceDollar /> Meus Boletos
                  </a>
                </li>
                <li>
                  <a href="/transferir-senha">
                    <FaExchangeAlt /> Transferir Senha
                  </a>
                </li>                
                <li className="logout" onClick={handleLogout}>
                  <FaSignOutAlt /> Sair
                </li>
              </ul>
            </div>
          )}
        </div>
      ) : (
        <div className="login">
          <a href="/login">
            <FaSignInAlt className="icon" /> Entrar
          </a>
        </div>
      )}

      <div className={`sidebar ${sidebarOpen ? "open" : ""}`}>
        <div className="sidebar-header">
          <span>MENU</span>
          <FaTimes className="close-icon" onClick={() => setSidebarOpen(false)} />
        </div>
        <ul className="sidebar-menu">
          <li>
            <a href="/">Quem Somos</a>
          </li>
          <li>
            <a href="/vaquejadas">Vaquejadas</a>
          </li>
          <li>
            <a href="/ranking">Ranking</a>
          </li>
          <li>
            <a href="/como-contratar">Como Contratar?</a>
          </li>
          <li>
            <a href="/meus-pedidos">Minhas Senhas</a>
          </li>
          <li>
            <a href="/meus-boletos">Meus Boletos</a>
          </li>
        </ul>
      </div>
    </nav>
  )
}

export default Navbar

